import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Dashboard() {
  const navigate = useNavigate();
  const [vendor, setVendor] = useState(null);
  const [loading, setLoading] = useState(true);

  function logout() {
    localStorage.removeItem("vendor_token");
    localStorage.removeItem("vendor_id");
    navigate("/login");
  }

  useEffect(() => {
    const token = localStorage.getItem("vendor_token");
    if (!token) return navigate("/login");

    async function loadVendor() {
      try {
        const response = await fetch("https://api.showmeyourjunk.biz/api/vendor/me", {
          method: "GET",
          headers: { "x-vendor-token": token }
        });

        const data = await response.json();

        if (!response.ok || !data.success) {
          logout();
          return;
        }

        setVendor(data.vendor);
        setLoading(false);
      } catch (err) {
        console.error("Failed to load vendor profile:", err);
        logout();
      }
    }

    loadVendor();
  }, [navigate]);

  if (loading) {
    return (
      <div style={{ padding: 40 }}>
        <h2>Loading dashboard...</h2>
      </div>
    );
  }

  return (
    <div style={{ padding: 10 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h1>
          Welcome, {vendor.business_name}
          {vendor.has_verified_payment && (
            <span
              style={{
                marginLeft: 12,
                padding: "4px 8px",
                backgroundColor: "#2ecc71",
                color: "#fff",
                borderRadius: 6,
                fontSize: 12,
                verticalAlign: "middle"
              }}
            >
              ✔ Verified
            </span>
          )}
        </h1>

        <button onClick={logout} style={{ height: 40 }}>
          Logout
        </button>
      </div>

      <div
        style={{
          marginTop: 20,
          padding: 20,
          border: "1px solid #ddd",
          borderRadius: 6,
          maxWidth: 500
        }}
      >
        <h3>Your Vendor Profile</h3>

        <p>
          <strong>Email:</strong> {vendor.email}
        </p>

        <p>
          <strong>Phone:</strong> {vendor.phone || "Not provided"}
        </p>

        <p>
          <strong>Service Zipcodes:</strong>{" "}
          {vendor.service_zipcodes || "None listed"}
        </p>

        {!vendor.has_verified_payment && (
          <div
            style={{
              marginTop: 10,
              padding: 10,
              backgroundColor: "#fff3cd",
              border: "1px solid #ffeeba",
              borderRadius: 4,
              color: "#856404"
            }}
          >
            <strong>Payment verification required:</strong>  
            You must verify a payment method before you can place bids on leads.
          </div>
        )}

        <button
          style={{ marginTop: 20 }}
          onClick={() => navigate("/available-leads")}
        >
          View Available Leads
        </button>
      </div>
    </div>
  );
}
